import { Dropdown } from "primereact/dropdown";
const { classNames } = require("primereact/utils")
const _props={
    categoryOptions:[],
    selectedCategory:{},
    setCategory:()=>{}
}
export function CategorySelecterDropdown(props = _props) {
    const handleChange = (e) => {
        const selectedCategoryObject = props.categoryOptions.find((obj) => obj.name === e.value);
        props.setCategory(selectedCategoryObject);
      };

    return <Dropdown dropdownIcon="fa fa-caret-down"
        id={'period'} className={classNames({})}
        placeholder={props.selectedCategory.name}
        value={props.selectedCategory}
        appendTo={'self'}
        options={props.categoryOptions.map((obj) => obj.name)}
        onChange={(e)=>handleChange(e)} />

}